<template>
    <div class="border border-gray-400 px-3 sm:px-6 pb-6 mt-2 mt-8 sm:-mt-px mb-8">
        <div class="font-bold pt-6 text text-blue-500 tracking-wide uppercase">
            {{ $t('Option Fee') }}
        </div>

        <option-fee-amount
            :commercial="commercial"
            :read_only="read_only"
            @change="optionFeeChanged"
        />

        <option-fee-received
            :commercial="commercial"
            :read_only="read_only"
        />

        <option-fee-toward-purchase
            :commercial="commercial"
            :option_fee_amount="option_fee"
            :read_only="read_only"
        />

        <option-fee-refundable
            :commercial="commercial"
            :option_fee_amount="option_fee"
            :read_only="read_only"
        />
    </div>
</template>

<script>
import OptionFeeAmount from './option-fee-amount.vue';
import OptionFeeReceived from './option-fee-received.vue';
import OptionFeeTowardPurchase from './option-fee-toward-purchase.vue';
import OptionFeeRefundable from './option-fee-refundable.vue';

export default {
    components: {
        OptionFeeAmount,
        OptionFeeReceived,
        OptionFeeTowardPurchase,
        OptionFeeRefundable,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            option_fee: this.commercial.option_fee_amount,
        }
    },

    methods: {
        optionFeeChanged(value) {
            this.option_fee = value;
        },
    },
}
</script>
